// extracted by mini-css-extract-plugin
module.exports = {"introTitle":"IntroTitle_introTitle__lH9A2","baffo":"IntroTitle_baffo__HRdro","label":"IntroTitle_label__YDpsi"};